import { useState, useEffect } from "react";
import { useModal } from "../../hooks";
import LavorisService from "../../services/LavorisService";
import AddADM from "../others/userModule/ADMAbsentee/addADM";
import EditADM from "../others/userModule/ADMAbsentee/editADM";
import InfiniteTable from "../../components/others/InfiniteTableComponent/IntiniteTableComponent";
import { getUserRolesTableColumns } from "./userRolesTableColumns";

const ADD_ADM_ABSENTEE_MODAL = "addADMAbsenteesModal";
const EDIT_ADM_ABSENTEE_MODAL = "editADMAbsenteesModal";

const ADMAbsentees = () => {
  const LavorisInstance = LavorisService.getInstance();

  // useStates
  const [tableLoading, setTableLoading] = useState(true);
  const { openModal, closeModal, isActive } = useModal();
  const [ADMAbsentees, setADMAbsentees] = useState<any[]>([]);
  const [ADMAbsentee, setADMAbsentee] = useState<any>(null);


  const getItems = async () => {
    setTableLoading(true);
    try {
      const response = await LavorisInstance.User.findUsersByRoleAlias("ADM_ABSENTEE");
      setADMAbsentees(response);
    } catch (error) {
      console.log(error);
    } finally {
      setTableLoading(false);
    }
  }
  useEffect(() => {
    const getData = async () => {
      await getItems()
    };
    getData();
  }, []);

  // Configuración de columnas para la tabla
  const requestedTurnsColumns = getUserRolesTableColumns((rowData) => {
    openModal(EDIT_ADM_ABSENTEE_MODAL, rowData.id);
    setADMAbsentee(rowData);
  });


  return (
    <>
      <div className="custom-header mt-sm-4 mt-0 pt-2">
        <div className="header-controls">
          {/* Search Section */}
          <div className="search-section">
          </div>

          {/* Actions Section */}
          <div className="actions-section">
            <button
              type="button"
              className="add-btn"
              onClick={() => {
                openModal(ADD_ADM_ABSENTEE_MODAL);
              }}
              title="Agregar"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M8 3.333v9.334M3.333 8h9.334"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="btn-text">Agregar</span>
            </button>
          </div>
        </div>
      </div>

      <InfiniteTable
        data={ADMAbsentees}
        columns={requestedTurnsColumns}
        loading={tableLoading}
        hasMore={false}
        onLoadMore={() => { }}
        height={300}
        emptyMessage="Momentáneamente no hay datos para mostrar"
        loadingMessage={ADMAbsentees.length === 0 ? "Cargando datos..." : "Buscando más datos..."}
        striped
        hover
        bordered
      />

      {isActive(ADD_ADM_ABSENTEE_MODAL) && (
        <AddADM
          show
          urlTittle={ADD_ADM_ABSENTEE_MODAL}
          onClose={() => closeModal(ADD_ADM_ABSENTEE_MODAL)}
          modalTittle="Agregar ADM de Ausentismos"
          tableLoading={getItems}
        />
      )}

      {isActive(EDIT_ADM_ABSENTEE_MODAL) && (
        <EditADM
          show
          urlTittle={EDIT_ADM_ABSENTEE_MODAL}
          onClose={() => closeModal(EDIT_ADM_ABSENTEE_MODAL)}
          modalTittle="Editar ADM de Ausentismos"
          data={ADMAbsentee}
          tableLoading={getItems}
        />
      )}
    </>
  );
};

export default ADMAbsentees;
